const REDIRECT_ACTIONS = new Set([
    "redirect_url",
    "redirect_3ds_url",
    "Redirect3DSUrl",
    "PAYMENT_INTENT_NEXT_ACTION_REDIRECT_3DS_URL",
    "payment_intent_next_action_redirect_3ds_url",
]);

const CLIENT_3DS_CONFIRM_ACTIONS = new Set([
    "client_3ds_confirm",
    "Client3DSConfirm",
    "use_stripe_sdk",
    "PAYMENT_INTENT_NEXT_ACTION_CLIENT_3DS_CONFIRM",
    "payment_intent_next_action_client_3ds_confirm",
]);

function normalizeClientNextAction(source) {
    if (source && source.data && source.data.client_next_action) {
        return source.data.client_next_action;
    }
    return source || {};
}

function normalizeActionValue(action) {
    return action == null ? "" : String(action).trim();
}

export function debugClientNextAction(label, source, extra = {}) {
    const next = normalizeClientNextAction(source);
    console.log(`[3DS][${label}] client_next_action`, {
        Action: normalizeActionValue(next.Action),
        redirect_url: next.redirect_url,
        return_url: next.return_url || next.ReturnUrl,
        client_secret: next.client_secret,
        payment_method: next.payment_method,
        internal_id: next.internal_id,
        html_form: next.html_form,
        ...extra,
    });
    return next;
}

export function getClientNextAction(source) {
    return normalizeClientNextAction(source);
}

export function getClientNextActionField(source, field, fallback = undefined) {
    const next = normalizeClientNextAction(source);
    return next && next[field] !== undefined ? next[field] : fallback;
}

export function syncClientNextAction(target, source, fieldMap = {}) {
    const next = debugClientNextAction("sync", source, {
        targetFields: {
            clientSecret: target.clientSecret,
            internalId: target.internalId,
        },
    });
    const mergedFieldMap = {
        client_secret: "clientSecret",
        internal_id: "internalId",
        ...fieldMap,
    };

    Object.keys(mergedFieldMap).forEach((sourceField) => {
        const targetField = mergedFieldMap[sourceField];
        if (next[sourceField] !== undefined) {
            target[targetField] = next[sourceField];
        }
    });

    return next;
}

export function isClientNextActionRedirect(source) {
    const next = normalizeClientNextAction(source);
    const action = normalizeActionValue(next.Action);
    return !!next.redirect_url && (!action || REDIRECT_ACTIONS.has(action));
}

export function getClient3DSConfirmPayload(source) {
    const next = normalizeClientNextAction(source);
    const action = normalizeActionValue(next.Action);
    const hasLegacyPayload = !!next.payment_method;
    const hasExplicitClient3DSAction =
        !!next.client_secret && CLIENT_3DS_CONFIRM_ACTIONS.has(action);

    if (!hasLegacyPayload && !hasExplicitClient3DSAction) {
        return null;
    }

    const payload = {
        action,
        clientSecret: next.client_secret,
        paymentMethod: next.payment_method,
        next,
    };
    console.log("[3DS][detect] confirm payload", payload);
    return payload;
}

export async function handleClientNextAction(source, options = {}) {
    const next = normalizeClientNextAction(source);
    const action = normalizeActionValue(next.Action);

    if (action === "html_form" && next.html_form) {
        if (options.onHtmlForm) {
            await options.onHtmlForm(next);
        }
        return { handled: true, action, next };
    }

    if (isClientNextActionRedirect(next)) {
        if (options.beforeRedirect) {
            await options.beforeRedirect(next);
        }

        if (options.onRedirect) {
            await options.onRedirect(next);
        } else if (typeof window !== "undefined") {
            window.location.href = next.redirect_url;
        }

        return { handled: true, action, next };
    }

    const client3DSConfirmPayload = getClient3DSConfirmPayload(next);
    if (client3DSConfirmPayload && options.onClient3DSConfirm) {
        if (options.beforeClient3DSConfirm) {
            await options.beforeClient3DSConfirm(next);
        }

        await options.onClient3DSConfirm(client3DSConfirmPayload);
        return { handled: true, action, next };
    }

    return { handled: false, action, next };
}
